<mat-dialog-content class="custom__class-dialog-success-modal">
  <div class="custom__class-dialog-success-modal-content">
    <img width="48px" height="48px" src="assets/images/icons/success-modal.png" alt="icon success modal">
  </div>
  <div class="custom__class-dialog-success-modal-content">
    <h1>{{ title | translate}}</h1>
    <span *ngIf="subtitle" class="custom__class-dialog-success-modal-content-subtitle">{{ subtitle | translate}}</span>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <common-buttons-filled class="custom__class-dialog-success-modal-actions" [label]="labelButtonSave | translate"
    [disabled]="false" (output)="onEventAccept(true)"></common-buttons-filled>
  <common-buttons-outlined *ngIf="labelButtonCancel" class="custom__class-dialog-cancel-modal-actions"
    [label]="labelButtonCancel | translate" [disabled]="false"
    (output)="onEventCancel(false)"></common-buttons-outlined>
</mat-dialog-actions>
